import React from "react";
import type { ToolCallInfo } from "../domain/types";

const TOOL_LABELS: Record<string, string> = {
  tv_list_projects: "Looking up projects",
  tv_create_project: "Creating project",
  tv_delete_project: "Deleting project",
  tv_queue_run: "Queuing model run",
  tv_get_run_status: "Checking run status",
  tv_methodology_info: "Looking up methodology",
  tv_get_results: "Fetching results",
  tv_compare_projects: "Comparing projects",
  tv_get_grid_info: "Fetching grid data",
  tv_get_portfolio_summary: "Summarizing portfolio",
  tv_get_regional_ranking: "Ranking regions",
  tv_get_equivalencies: "Calculating equivalencies",
  tv_generate_narrative: "Generating narrative",
  tv_get_usage_status: "Checking usage",
  tv_submit_batch: "Submitting batch",
  tv_get_batch_status: "Checking batch status",
  tv_get_batch_summary: "Getting batch summary",
  tv_search_generators: "Searching generators",
  tv_get_generator_detail: "Loading generator details",
  tv_claim_generator: "Claiming generator",
  tv_estimate_impact: "Estimating impact",
  tv_get_grid_snapshot: "Loading grid snapshot",
};

function getLabel(name: string): string {
  return TOOL_LABELS[name] || name.replace("tv_", "").replace(/_/g, " ");
}

interface Props {
  toolCalls: ToolCallInfo[];
}

const ToolCallIndicator: React.FC<Props> = ({ toolCalls }) => {
  if (!toolCalls.length) return null;

  return (
    <div className="flex flex-wrap gap-1.5 mb-1.5">
      {toolCalls.map((tc, i) => (
        <span
          key={`${tc.name}-${i}`}
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs ${
            tc.status === "pending"
              ? "bg-quantum-500/20 text-quantum-400"
              : tc.status === "ok"
              ? "bg-green-500/20 text-green-400"
              : "bg-red-500/20 text-red-400"
          }`}
        >
          {tc.status === "pending" && (
            <span className="inline-block w-3 h-3 border-2 border-quantum-400 border-t-transparent rounded-full animate-spin" />
          )}
          {tc.status === "ok" && <span>&#10003;</span>}
          {tc.status === "error" && <span>&#10007;</span>}
          {getLabel(tc.name)}
        </span>
      ))}
    </div>
  );
};

export default ToolCallIndicator;
